import { type OriginStep, type StepItem, StepItemStatus } from '@pkg/types';

export type StepItemWithKind = StepItem & { kind: OriginStep['kind'] };

export function getCurrentStepItems(steps: OriginStep[]) {
    return steps.reduce((stepItems: StepItemWithKind[], currentStep: OriginStep) => {
        const stepItemsWithKind = currentStep.items
            .map((item) => ({ ...item, kind: currentStep.kind }))
            .filter((item) => item.status !== StepItemStatus.COMPLETE);
        return [...stepItems, ...stepItemsWithKind];
    }, [] as StepItemWithKind[]);
}
